export default __webpack_public_path__ + "static/media/img8.0c0d93ca.webp";